module.exports = {
	name: 'Octopharma - Mirta web app',
	shortName: 'Mirta',
	description: 'Octopharma portal version of the mobile app',
	primaryColor: '#02855b',
	secondaryColor: '#13a689',
	msTileColor: '#02855b'
}